const apiConfig = {
  ApplicationID: process.env.REACT_APP_APPLICATION_ID, // '25117235-706a-431a-8486-dd820992c899'
  // ApplicationIDPetroHub: process.env.REACT_APP_APPLICATION_ID_PETROHUB, // '37808558-15fd-11f1-8003-06987a6342bb'
  // IAMUrl: 'https://localhost:5555',
  SInspectAPIUrl: process.env.REACT_APP_SINSPECT_API_Url,
  SInspectSignalRAPIUrl: window.location.hostname.toLowerCase().startsWith('petrohub') || process.env.REACT_APP_IS_USER_LOGGED_BY_PETROHUB === 'true' ? process.env.REACT_APP_signalR_API_Url_Petrohub : process.env.REACT_APP_signalR_API_Url,
  IAMUrl: process.env.REACT_APP_IAM_API_Url,
  // PortalAPIUrl: 'https://localhost:7001/api/v1',
  PortalAPIUrl: window.location.hostname.toLowerCase().startsWith('petrohub') || process.env.REACT_APP_IS_USER_LOGGED_BY_PETROHUB === 'true' ? process.env.REACT_APP_Portal_API_Url_Petrohub : process.env.REACT_APP_Portal_API_Url,
  // PortalAPIUrl: process.env.REACT_APP_Portal_API_Url,
  PTPAPIUrl: process.env.REACT_APP_PTP_API_Url,
  NotificationAPIUrl: process.env.REACT_APP_Notification_API_Url,
  // NotificationAPIUrl: 'https://localhost:7110/api/v1',
  APIKey: process.env.REACT_APP_API_KEY, // 'HX9dyuqsGsx4'
  Key_Salt: process.env.REACT_APP_ABV_API_X_Key_Salt, // 'ABV_API_X_Key_Salt_12345',
  APIKeyPetrohub: process.env.REACT_APP_API_KEY_PETROHUB,
  UtilsAPIUrl: process.env.REACT_APP_Utils_API_Url,
  KCMS_API: process.env.REACT_APP_KC_API_Url,
};

export default apiConfig;
